import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import {
  AreaChartBase,
  BarChartBase
} from 'modules';
import { ReactNode } from 'react';



export type CustomChartProps = {
  type: 'AREA' | 'BAR' | 'LINE';
  data: {
    name: string;
    rate: string;
  }[];
  title: string;
  subTitle?: string | undefined;
  filterButton?: ReactNode | ReactNode[] | undefined;
  children?: ReactNode | ReactNode[];
  yDomain?: [number, number];
};

/**
 * @abstract wrapper that depending on type of rechart will return chart with data
 * @param props
 * @returns
 */
export const FC = (props: CustomChartProps) => {
  const theme = useTheme();
  return (
    <Box
      // flex = '1 1 0'
      display='flex'
      flexDirection='column'
      borderRadius='1rem'
      border={`1px solid ${theme.palette.gray.light20}`}
      minHeight='400px'
      paddingTop='1rem'
      paddingRight='1rem'
      sx={{
        background: `repeating-linear-gradient(35deg,
          ${theme.palette.gray.light05} 8px,
          ${theme.palette.gray.light10} 11px,
          ${theme.palette.gray.light20} 12px,
          ${theme.palette.gray.light10} 13px
        )`
      }}
    >
      <Stack
        direction='row'
        paddingLeft='1rem'
        paddingBottom='.75rem'
      >
        <Typography variant='chartTitle'>{props.title ?? 'Title'}</Typography>
      </Stack>
      <Box
        flex='1 1 0'
      >
        {props.type === 'BAR' && (
          <BarChartBase.FC
            data={props.data}
          />
        )}
        {props.type === 'AREA' && (
          <AreaChartBase.FC
            yDomain={props.yDomain}
            data={props.data}
          />
        )}
        {/* chart type used to determine which base rechart is used. */}
      </Box>
      <Stack direction='row' paddingX='1rem' paddingBottom='1rem'>
        {props?.children}
      </Stack>
    </Box>
  );
};
